module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.4177a9ff.eot";